<template>
  <div class="page-container">
    <div class="settings-form">
      <h2 class="page-title">发布设置</h2>
      <el-form :model="form" label-width="140px" class="compact-form">
        <!-- 发布模式 -->
        <div class="setting-section">
          <el-form-item label="发布模式：" class="form-item-row">
            <el-radio-group v-model="form.release_mode" class="mode-group">
              <el-radio :label="1" border size="large" class="mode-radio">
                <div class="mode-content">
                  <span class="radio-label">API发布</span>
                  <span class="radio-tip">实时接口推送</span>
                </div>
              </el-radio>
              <el-radio :label="2" border size="large" class="mode-radio">
                <div class="mode-content">
                  <span class="radio-label">RPA发布</span>
                  <span class="radio-tip">自动化流程处理</span>
                </div>
              </el-radio>
              <el-radio :label="3" border size="large" class="mode-radio">
                <div class="mode-content">
                  <span class="radio-label">仅创建草稿</span>
                  <span class="radio-tip">后续手动处理发布</span>
                </div>
              </el-radio>
            </el-radio-group>
          </el-form-item>

          <div class="api-notice" v-if="form.release_mode === 1">
            <el-alert type="info" :closable="false">
              <span>目前API发布仅支持企业号且已认证的公众号</span>
              <el-link type="primary"
                href="https://developers.weixin.qq.com/doc/subscription/guide/product/publish.html" target="_blank"
                class="notice-link">
                查看官方文档 <el-icon>
                  <TopRight />
                </el-icon>
              </el-link>
            </el-alert>
          </div>
        </div>

        <!-- 服务器信息 -->
        <div class="setting-section server-info">
          <el-form-item label="服务器信息：" class="form-item-row">
            <div class="server-info-content">
              <div class="ip-display">
                <el-icon class="ip-icon">
                  <Monitor />
                </el-icon>
                <div class="ip-text">
                  <div class="ip-title">当前服务器IP</div>
                  <div class="ip-value">{{ serverIP }}</div>
                </div>
              </div>
              <div class="server-tip">
                <el-icon class="tip-icon">
                  <InfoFilled />
                </el-icon>
                <span>系统将使用此IP与微信服务器通信</span>
              </div>
            </div>
          </el-form-item>
        </div>

        <!-- 操作按钮 -->
        <div class="form-actions">
          <el-button type="primary" size="large" class="submit-btn" @click="submitForm" :loading="loading">
            <el-icon class="btn-icon">
              <Check />
            </el-icon>
            保存配置
          </el-button>
          <el-button type="danger" size="large" class="reset-btn" @click="resetConfig" :disabled="!hasData">
            <el-icon class="btn-icon">
              <Delete />
            </el-icon>
            恢复默认
          </el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import config from '@/config.js';
import Cookies from 'js-cookie';
import {
  InfoFilled,
  Monitor,
  Check,
  Delete,
  TopRight
} from '@element-plus/icons-vue'

export default {
  name: 'SystemPublish',
  components: { InfoFilled, Monitor, Check, Delete, TopRight },
  data() {
    return {
      loading: false,
      hasData: false,
      serverIP: '127.0.0.1', // 使用您提供的IP
      form: {
        release_mode: 1
      }
    }
  },
  computed: {
    userInfo() {
      return JSON.parse(Cookies.get('user_info') || '{}')
    }
  },
  mounted() {
    this.fetchConfig()
    this.getServerIP()
  },
  methods: {


    // 获取服务器IP
    async getServerIP() {
      try {
        const { data } = await axios.get(`${config.BASE_URL}/shop/api/get_server_ip.php`)
        this.serverIP = data.ip || '获取失败'
      } catch {
        this.serverIP = '127.0.0.1'
      }
    },
    async fetchConfig() {
      try {
        const { data } = await axios.post(`${config.BASE_URL}/shop/api/LaBasicSettingsController.php`, {
          action: 'get',
          store_id: this.userInfo.id
        })

        if (data.data?.length > 0) {
          const configData = data.data[0]
          this.hasData = true
          this.form = {
            release_mode: configData.release_mode || 1
          }
        }
      } catch (error) {
        this.$message.error('获取配置失败')
        console.error('获取配置错误:', error);
      }
    },

    async submitForm() {
      this.loading = true
      try {
        const payload = {
          store_id: this.userInfo.id,
          release_mode: this.form.release_mode
        }

        const action = this.hasData ? 'update' : 'add'
        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/LaBasicSettingsController.php`,
          { action, ...payload }
        )

        if (data.success) {
          this.$message.success('配置保存成功')
          this.hasData = true
          await this.fetchConfig()
        }
      } catch (error) {
        const errorMsg = error.response?.data?.error ||
          error.message ||
          '服务器错误，请检查控制台';
        this.$message.error(`保存失败：${errorMsg}`);
        console.error('保存错误详情:', error);
      } finally {
        this.loading = false
      }
    },

    resetConfig() {
      this.$confirm('确定要重置所有配置吗？该操作不可恢复！', '警告', {
        confirmButtonText: '确认重置',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'reset-confirm',
        confirmButtonClass: 'el-button--danger'
      }).then(async () => {
        try {
          const { data } = await axios.post(
            `${config.BASE_URL}/shop/api/LaBasicSettingsController.php`,
            { action: 'reset', store_id: this.userInfo.id }
          )

          if (data.success) {
            this.$message.success('配置已重置')
            this.hasData = false
            this.form = {
              release_mode: 1
            }
          }
        } catch (error) {
          this.$message.error('重置失败')
        }
      }).catch(() => { })
    }
  }
}
</script>

<style scoped lang="scss">
.page-container {
  padding: 20px;
  display: flex;
  justify-content: center;
}

.settings-form {
  width: 95%;
  margin: 0 auto;
  padding: 32px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 9px 20px rgba(0, 0, 0, 0.05);
}

.page-title {
  font-size: 22px;
  color: #1f2937;
  margin-bottom: 32px;
  font-weight: 600;
  text-align: center;
  position: relative;
  padding-bottom: 12px;

  &::after {
    content: '';
    display: block;
    width: 50px;
    height: 3px;
    background: linear-gradient(90deg, #3b82f6, #8b5cf6);
    margin: 12px auto 0;
    border-radius: 3px;
  }
}

.compact-form {
  :deep(.el-form-item__label) {
    font-size: 15px;
    color: #4b5563;
    line-height: 40px;
    padding-right: 20px !important;
    font-weight: 500;
  }

  .form-item-row {
    margin-bottom: 24px;
  }
}

.setting-section {
  background: #f9fafb;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid #e5e7eb;

  &.server-info {
    background: #f8fafc;
  }
}

.mode-group {
  display: flex;
  gap: 12px;

  :deep(.el-radio) {
    margin: 0;
    border-radius: 8px;
    overflow: hidden;

    &.el-radio--large {
      height: 80px;

      .el-radio__label {
        padding-left: 0;
      }
    }

    .el-radio__input {
      display: none;
    }

    &.is-checked {
      border-color: #3b82f6 !important;
      background-color: rgba(59, 130, 246, 0.05);
    }
  }
}

.mode-radio {
  width: 220px;
  height: 80px;
  padding: 12px 16px;
  border: 1px solid #e5e7eb !important;
  transition: all 0.2s;

  &:hover {
    border-color: #3b82f6 !important;
    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.1);
  }
}

.mode-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;

  .radio-label {
    font-size: 15px;
    font-weight: 500;
    color: #1f2937;
    margin-bottom: 4px;
  }

  .radio-tip {
    font-size: 12px;
    color: #6b7280;
  }
}

.api-notice {
  margin-top: 16px;

  .el-alert {
    padding: 8px 16px;
    background-color: #f0f9ff;
    border: 1px solid #e0f2fe;
  }

  .notice-link {
    margin-left: 8px;
    display: inline-flex;
    align-items: center;
    font-size: 13px;

    .el-icon {
      margin-left: 2px;
      font-size: 14px;
    }
  }
}

.server-info-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ip-display {
  display: flex;
  align-items: center;
  background: white;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;

  .ip-icon {
    font-size: 20px;
    color: #3b82f6;
    margin-right: 12px;
  }

  .ip-text {
    .ip-title {
      font-size: 13px;
      color: #6b7280;
      margin-bottom: 2px;
    }

    .ip-value {
      font-size: 16px;
      font-weight: 500;
      color: #1f2937;
      font-family: 'Courier New', monospace;
    }
  }
}

.server-tip {
  color: #6b7280;
  font-size: 12px;
  display: flex;
  align-items: center;
  margin-top: 8px;

  .tip-icon {
    color: #3b82f6;
    margin-right: 8px;
    font-size: 14px;
  }
}

.form-actions {
  margin-top: 32px;
  text-align: center;
  display: flex;
  justify-content: center;
  gap: 16px;

  .submit-btn,
  .reset-btn {
    width: 160px;
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 8px;
    font-weight: 500;
    transition: all 0.2s;

    .btn-icon {
      margin-right: 6px;
      font-size: 16px;
    }

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
  }
}
</style>